// src/config/contactConfig.js

const contactConfig = {
  email: "Contact@purvsoft.com",
  phone: "+919408670766",
  address: "Sv Square, 333,Near GST Road, New Ranip.Ahmedabad, Gujarat 382470",
  Time:'Mon-Sat 10:30am To 7:30pm',
};

export default contactConfig;
